import React from "react";
import "./customerProfile.scss";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";

const CustomerProfile = ({ cusId }) => {
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiRes, setApiRes] = useState("false");

  useEffect(() => {
    if (!cusId) {
      return;
    }
    const getProfile = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/get-customer-profile/${cusId}`);
        setProfile(response.data);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };
    getProfile();
  }, [cusId, apiRes]);

  const handleStatus = async (status) => {
    if (!status || !cusId) {
      return;
    }
    try {
      const response = await axios.put(
        `/update-customer-status/${cusId}?status=${status}`
      );
      setApiRes(response.data);
    } catch (error) {
      return;
    }
  };

  return (
    <>
      {loading ? (
        <div className="cus_wrp">
          <p>Loading...</p>
        </div>
      ) : (
        <div className="cus_wrp">
          <small>{cusId}</small>
          <h5>{profile?.fullName}</h5>
          <p>{profile.email}</p>

          <div>
            <strong>Address</strong>
            <p>
              {profile.address}, {profile.homeName}, {profile.landmark},{" "}
              {profile.city}
            </p>
          </div>

          <div>
            <strong>Status</strong>
            <span className={`status ${profile.isVerified?.toLowerCase()}`}>
              {profile.isVerified}
            </span>
          </div>
          <div>
            <div className="v_btn" onClick={() => handleStatus("verify")}>
              <span>Verify</span>
            </div>
            <div className="v_btn" onClick={() => handleStatus("unverify")}>
              <span>Unverify</span>
            </div>
            <div className="v_btn" onClick={() => handleStatus("block")}>
              <span>Block</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerProfile;
